<div class="bg-white rounded p-2 opacity-50">
	<p class="text-xs text-end text-grey">Powered By</p>
	<div>
		<img src="/assets/images/integrations/treefort-logo.svg" />
	</div>
</div>
